import { NAME } from "./constants";

export const getProjectNewNoteContents = (state) => {
  return state.pages.projectView.modalData[NAME].newNote;
};
